import { useEffect, useState } from "react";
import { Input, Modal } from "@iq/models"
import { updateTrackingNumber } from "../../services/OrderService";


function OrderDetails({ 
    isOpen, 
    order, 
    onClose,  
    onTrackingNumberChange = () => {},
}) {
    const [trackingNumber, setTrackingNumber] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setTrackingNumber(order?.tracking_number || "");
        setErrorMessage("");
    }, [order]);

    if (!order) return null;

    const items = Array.isArray(order.order_items) ? order.order_items : [];

    async function handleSaveTrackingNumber() {
        setIsSaving(true);
        setErrorMessage("");

        try {
            await updateTrackingNumber(order.id, trackingNumber);
            onTrackingNumberChange(order.id, trackingNumber);
            onClose();
        } catch (error) {
            setErrorMessage(error.message);
        } finally {
            setIsSaving(false);
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={`Order #${order.id}`}
            errorMessage={errorMessage}
            actionButtons={[{
                label: isSaving ? "Saving..." : "Save Tracking Number",
                onClick: handleSaveTrackingNumber,
                disabled: isSaving,
            }]}
        >
            <p>Customer: {order.customer_name || `Customer #${order.customer_id}`}</p>
            <p>Status: {order.status}</p>
            <ul>
                {items.map((item) => (
                    <li key={item.id}>
                        {item.product_name} x{item.quantity}
                        {formatAttributes(item.attributes_values)} — {formatCurrency(item.price * item.quantity)}
                    </li>
                ))}
            </ul>
            <p>Total: {formatCurrency(order.total_amount)}</p>
            <Input 
                label="Tracking Number" 
                value={trackingNumber} 
                onChange={(e) => setTrackingNumber(e.target.value)} 
            />

        </Modal>
    );
}

function formatAttributes(attributes) {
    if (!Array.isArray(attributes) || attributes.length === 0) {
        return "";
    }

    return ` (${attributes.map((attribute) => `${attribute.name}: ${attribute.value}`).join(", ")})`;
}

function formatCurrency(amount) {
    const cents = Number(amount);

    if (!Number.isFinite(cents)) {
        return "-";
    }

    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    }).format(cents / 100);
}

export default OrderDetails;